<template>
  <div class="file">
    <div class="card-item" v-for="(file,index) in fileResult" :key="index"
         @click="handleReturnPdf(file.fullFileName)">
      <i class="pdf"></i>
      <span v-html="file.fileName"/>
    </div>
  </div>
</template>

<script>
import {configManager} from "@zhoujianhui/vip-core";

export default {
  name: "FtaInformationFile",
  data() {
    return {
      fileResult: [],
      keyword: ""
    }
  },
  created() {
    this.initFileResult();
    this.highlight();
  },
  methods: {
    initFileResult() {
      const fileResult = this.$route.query.fileResult;
      this.keyword = this.$route.query.keyword;
      this.fileResult = fileResult.map(item => {
        const name = item.split("/")[1]
        const fileNamesSplits = name.split(this.keyword);
        fileNamesSplits.splice(1, 0, "<span style='color:#1989fa;font-weight: bold'>" + this.keyword + "</span>");
        const fileName = fileNamesSplits.join('');
        return {
          fileName: fileName,
          fullFileName: item,
        }
      })
      console.log(this.fileResult);
    },

    handleReturnPdf(fullFileName) {
      window.EappApi.goThirdUrl(configManager.getConfig().pdfViewerUrl + "?file=https://zumoo-public.oss-cn-nanjing.aliyuncs.com/attachment/" + fullFileName);
    }
  }

}
</script>

<style lang="scss" scoped>
.file {

  .card-item {
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
    height: 0.6rem;
    background: #ffffff;
    margin-bottom: 0.2rem;

    span {
      max-width: calc(100% - .54rem);
    }

  }

  .card-item i {
    width: 0.34rem;
    height: 0.4rem;
  }

  .card-item .pdf {
    background: url("../images/pdf.png") no-repeat;
    display: block;
    background-size: 100% 100%;
  }

  .card-item span {
    line-height: 0.16rem;
    color: #333;
    font-size: 0.14rem;
    font-weight: bold;
    margin-left: 0.2rem;
  }
}
</style>